import { useAccountStore } from "@/modules/account/store"

export function getPublicApiTokenDetailPageRoutes(currentModule: string, routePrefix: string) {
  return [
    {
      path: routePrefix,
      name: `${currentModule}/public-api-token-outlet`,
      component: () => import("./components/PublicApiTokenDetailWrapper.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [
        {
          path: `:user/general`,
          name: `${currentModule}/public-api-token-general`,
          component: () => import("./views/PublicApiTokenEditGeneral.vue"),
          meta: {
            isDetailPage: true,
            module: "settings",
          },
        },
      ],
    },
  ]
}

export function getSettingsRoutes() {
  return [
    {
      path: "/settings/metafields",
      name: "settings/metafields",
      component: () => import("./views/MetafieldsList.vue"),
      children: [
        {
          path: "detail",
          name: "settings/metafield-outlet",
          component: () => import("./components/MetafieldDetailWrapper.vue"),
          meta: { isDetailPageOutlet: true },
          children: [
            {
              path: ":metafield(-1|[0-9]+)/general",
              name: "settings/metafield-general",
              component: () => import("./views/MetafieldEditGeneral.vue"),
              meta: { isDetailPage: true, module: "settings" },
            },
          ],
        },
      ],
      beforeEnter: async () => {
        const accountStore = useAccountStore()
        if (!accountStore.isLoggedIn) {
          return { name: "login" }
        }
        await accountStore.fetchRights()
        if (!accountStore.isSuperAdmin) {
          return { name: "dashboard" }
        }
        return true
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import(/* webpackChunkName: settings-old-backend */ "./components/SettingOld.vue"),
    },
    {
      path: "/settings/old/cron-jobs",
      name: "settings/old/cron-jobs",
      component: () => import("./components/SettingCronJobsOld.vue"),
    },
    {
      path: "/settings/public-api-tokens",
      name: "settings/public-api-tokens",
      component: () => import("./views/PublicApiTokenList.vue"),
      children: getPublicApiTokenDetailPageRoutes("settings", "detail"),
    },
    {
      path: "/settings/cron-jobs",
      name: "settings/cron-jobs",
      component: () => import("./views/CronJobsList.vue"),
    },
    {
      path: "/settings/kee-credits",
      name: "settings/kee-credits",
      component: () => import("./kee-credits/views/KeeCreditList.vue"),
    },
  ]
}
